<div mat-dialog-title class="dialog-title">
    <button
      type="button"
      class="btn-close close-btn"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="closeDialog()"
    ></button>
    {{ dialogTitle }}
  </div>
  
  <div mat-dialog-content class="asd">
    <!-- Loader shown while content is loading -->
    <div *ngIf="isLoading" class="loader">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
    <!-- Render API response HTML content -->
    <div *ngIf="!isLoading">
      <div [innerHTML]="dialogContent" class="api-response-content"></div>
    </div>
  </div>